import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';

/** Document-root entities rendered as financial documents (document board, doc preview, financial card). */
export const FINANCIAL_DOCUMENT_ENTITIES: ReadonlySet<ActivityEntityName> = new Set([ActivityEntityName.Quote, ActivityEntityName.QuotePro, ActivityEntityName.QuoteTemplate, ActivityEntityName.SaleOrder, ActivityEntityName.PurchaseOrder, ActivityEntityName.Invoice, ActivityEntityName.Bill]);

export function isFinancialDocumentEntity(entity: ActivityEntityName | undefined): boolean {

  return entity != null && FINANCIAL_DOCUMENT_ENTITIES.has(entity);
}
